var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultImgDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 210,
    height: 233,
    viewBox: "0 0 210 233",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_953",
    x: 0,
    y: 0,
    width: 210,
    height: 233,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_953-2",
    x: 0,
    y: 0,
    width: 210,
    height: 233,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2025",
    "data-name": "Groupe 2025",
    transform: "translate(-1213.865 -950.789)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1213.86, 950.79)",
    filter: "url(#Rectangle_953)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_953-3",
    "data-name": "Rectangle 953",
    width: 192,
    height: 215,
    rx: 10,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1213.86, 950.79)",
    filter: "url(#Rectangle_953-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_953-4",
    "data-name": "Rectangle 953",
    width: 192,
    height: 215,
    rx: 10,
    transform: "translate(9 6)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-file-pdf",
    "data-name": "Icon awesome-file-pdf",
    d: "M40.5,57.026c-1.113-3.563-1.091-10.443-.445-10.443C41.929,46.582,41.75,54.8,40.5,57.026Zm-.379,10.51A102.746,102.746,0,0,1,33.8,81.5c4.075-1.559,8.684-3.83,14.006-4.876A28.844,28.844,0,0,1,40.125,67.535ZM19.172,95.325c0,.178,2.939-1.2,7.771-8.951C25.451,87.776,20.463,91.829,19.172,95.325Zm36.05-59.7H85.5v73.035a5.331,5.331,0,0,1-5.344,5.344H5.344A5.331,5.331,0,0,1,0,108.662V5.344A5.331,5.331,0,0,1,5.344,0H49.878V30.283A5.36,5.36,0,0,0,55.222,35.627ZM53.441,73.882c-4.453-2.717-7.415-6.457-9.508-11.98,1-4.119,2.583-10.376,1.381-14.3-1.047-6.546-9.441-5.9-10.644-1.514-1.113,4.075-.089,9.82,1.8,17.146a209.093,209.093,0,0,1-9.085,19.1c-.022,0-.022.022-.045.022-6.034,3.1-16.388,9.909-12.135,15.141A6.919,6.919,0,0,0,20,99.733c3.986,0,7.949-4.008,13.605-13.761,5.745-1.893,12.046-4.253,17.591-5.166,4.832,2.628,10.488,4.342,14.251,4.342,6.5,0,6.947-7.125,4.387-9.664-3.1-3.028-12.091-2.16-16.388-1.6Zm30.506-50.5L62.125,1.559A5.34,5.34,0,0,0,58.339,0H57V28.5H85.5V27.143A5.327,5.327,0,0,0,83.946,23.38Zm-16.5,56.847c.913-.6-.557-2.65-9.53-2C66.177,81.742,67.446,80.228,67.446,80.228Z",
    transform: "translate(1276.374 1007.023)",
    fill: "#9c342e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultImgDocument);
export default __webpack_public_path__ + "static/media/default-img-document.7a593f1c7865e1e98225e7636cb5e72d.svg";
export { ForwardRef as ReactComponent };